import { gql } from '@apollo/client';
import { Text } from '@mnd-frontend/ui/publish/components';
import { useGetUserLocaleQuery } from '../../../../../../../generated/hooks';
import { ExternalLink } from '../../../../../../../modules/global/components/Widgets/HelpPanel/components';
import routes from '../../../../../../../routes';

gql`
  query GetUserLocale {
    me {
      id
      user {
        id
        locale: locale2
      }
    }
  }
`;

const MndLibrary = () => {
  const { data } = useGetUserLocaleQuery();

  return (
    <>
      <Text as="h3" variant="headlineSmall">
        Mynewsdesk library
      </Text>
      <Text as="p" variant="body">
        It’s not always easy to create good content, get great reach and do useful insights. To help
        you become a better communicator, we have created a library full of different templates,
        recorded webinars and e-books to read or download.
      </Text>
      <ExternalLink
        link={routes.external.library(data?.me?.user?.locale)}
        text="Visit the library"
        withBorder
      />
    </>
  );
};

export default MndLibrary;
